const CookieNotification = ( ( window, undefined ) => {

  const cookie = document.getElementById('cookie_notif') || null,
        button = document.getElementById('cookie_notif_button') || null,
        buttonContent = document.getElementById('cookie-content') || null,
        loader = document.getElementById('cookie-loader') || null,
        hidden = 'is-hidden';

  const _closeCookie = e => {
    helpers.addClass( buttonContent, hidden );
    helpers.removeClass( loader, hidden );
    e.preventDefault();
    $.ajax({
      url: wgd_params.ajax_url,
      type: 'post',
      data: {
        action: 'set_cookie_notification',
      },
      success: function() {
        helpers.addClass( cookie, 'is-closed');
      }
    });
  };

  const init = function () {
    if ( button !== null && cookie !== null ) button.addEventListener('click', _closeCookie );
  };

    return {
    init: init
  };

})( window );
